module.exports = __webpack_public_path__ + "img/background.63bda4fe.svg";